"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorePluginMessages = void 0;
var CorePluginMessages;
(function (CorePluginMessages) {
    CorePluginMessages["CORE_MODULE_PLUGIN_WITHOUT_NAME"] = "Plugin without name, it is required";
})(CorePluginMessages || (exports.CorePluginMessages = CorePluginMessages = {}));
//# sourceMappingURL=messages.js.map